import SiafLiteApiRepository from "../../external/siafLiteApi";

class NotificacaoService {
  constructor() {
    this.urlBase = "/notificacao";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  async getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  async marcarTodasComoLida() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/marcar-como-lida`).get();
  }

  async marcarComoLida(id) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/marcar-como-lida/${id}`
    ).get();
  }
}

export default NotificacaoService;
